import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  id: string;
  goodItemId: string;
  file: File;
}
export const useManuallySetScreenshot = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, goodItemId, file }: HookProps) => {
      if (goodItemId?.length && file) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('goodItemId', goodItemId);

        const result = await apiClient.declarationsDocuments.manuallySetScreenshot.mutation({
          params: { id },
          body: formData as any,
        });

        if (result.status !== 200) throw result.body;
      }
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['declaration', variables.id] });
      toast.success('Screenshot was set successfully!');
    },
    onError: (error) => {
      showErrorToast(error, `Error setting the screenshot!`);
    },
  });
};
